import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import styles from './styles.module.scss';
import { Slider } from '../../../common/Slider';
import useScreen from '../../../../utils/hooks/useScreen';

export type stack = {
  iconName?: string;
  text: string;
  caption?: string;
};

interface IProps {
  arr: stack[];
  renderCard: (el: stack) => ReactNode;
  columnsCount?: 2;
}

const ListSlider: FC<IProps> = ({ arr, renderCard, columnsCount }) => {
  const { isMobile } = useScreen();

  if (isMobile) {
    return (
      <Slider
        sliderProps={{
          mouseDrag: true,
          slideBy: 'page',
          controls: false,
          nav: false,
          center: true,
          loop: false,
          lazyload: false,
          swipeAngle: 45,
          gutter: 8,
        }}
        className={styles.slider}
        containerClassName={styles.container}
      >
        {arr.map((el) => (
          <div key={el.text}>{renderCard(el)}</div>
        ))}
      </Slider>
    );
  }

  const hasCaption = arr.some((item) => item.caption);

  return (
    <div
      className={classNames(
        styles.cards,
        hasCaption && styles.cardsWithCaption,
        columnsCount === 2 && styles.cardsWithTwoColumns
      )}
    >
      {arr.map((el) => renderCard(el))}
    </div>
  );
};

export { ListSlider };
